"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.upgradeDataPropsInterface = void 0;

var _react = require("react");

var _products = require("ui-addon-upgrades/_core/common/data/upgradeData/properties/products");

var _upgradeProducts = require("ui-addon-upgrades/_core/common/data/upgradeData/properties/upgradeProducts");

var upgradeDataPropsInterface = {
  upgradeData: _react.PropTypes.shape({
    product: _react.PropTypes.oneOf(_products.productValues),
    app: _react.PropTypes.string,
    screen: _react.PropTypes.string,
    upgradeProduct: _react.PropTypes.oneOf(_upgradeProducts.upgradeProductValues)
  })
};
exports.upgradeDataPropsInterface = upgradeDataPropsInterface;